<template>
    <div class="card shadow"
         :class="type === 'dark' ? 'bg-default': ''"
         v-bind:style="{cursor:pointer2}">
        <div class="card-header border-0"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        {{title}}
                    </h3>
                    <h4 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                        {{$formatCurrency(amount)}}
                    </h4>
                </div>
                <!--div class="col text-right">
                    <base-button type="primary" size="sm" v-on:click="onNewItem">Nuevo</base-button>
                </div-->
            </div>
        </div>

        <div class="table-responsive" v-bind:style="{cursor:pointer}">
            <base-table class="table align-items-center table-flush"
                        :class="type === 'dark' ? 'table-dark': ''"
                        :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                        tbody-classes="list"
                        :data="data">
                        <!--@click="movementSelected"-->

                <template slot="columns">
                    <th v-bind:style="{cursor:pointer2}">Movimiento</th>
                    <th v-bind:style="{cursor:pointer2}">Tipo</th>
                    <th v-bind:style="{cursor:pointer2}">Cantidad</th>
                    <th v-bind:style="{cursor:pointer2}">Fecha</th>
                </template>

                <template slot-scope="{row}">
                    <th scope="row">
                        <div class="media align-items-center">
                            <div class="media-body">
                                <span class="name mb-0 text-sm">{{row.m_id}}</span>
                            </div>
                        </div>
                    </th>
                    <td>{{getMovType(row.type)}}</td>
                    <td>{{$formatCurrency(row.amount)}}</td>
                    <td>{{formatDate(row.date)}}</td>
                </template>
            </base-table>
        </div>

        <div v-if="pagination.total > pagination.perPage" class="card-footer d-flex justify-content-end"
             :class="type === 'dark' ? 'bg-transparent': ''">
            <base-pagination
                    size="sm"
                    :total="pagination.total"
                    :per-page="pagination.perPage"
                    :value="pagination.currentPage"
                    v-on:pageSelected="pageSelected"/>
        </div>

    </div>
</template>
<script>
    export default {
        name: 'movements-table',
        props: {
            type: {
                type: String
            },
            title: String,
            amount: Number,
            data: Array,
            pagination: Object
        },
        data() {
            return {
                tableData: [],
                pointer: 'pointer',
                pointer2: 'default'
            }
        },
        methods: {
            pageSelected(page) {
                this.$emit("pageSelected", page);
            },
            formatCurrency(value) {
                return this.$formatCurrency(value)
            },
            formatDate(date) {
               return this.$formatDate(date)
            },
            getMovType(type){
                return type==='payment'? 'Pago': type==='comission'? 'Comisión' : 'Cuenta bancaria'
            }
            /*onNewItem() {
                this.$emit("onNewItem")
            },
            movementSelected(payment) {
                this.$emit("onMovementSelected", payment)
            }*/
        }
    }
</script>
<style>
</style>
